import { queriesEngagements } from "@query";
import {
  WSEmptyState,
  WSTable,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";

import {
  buildEngagementTypeDetailsURL,
  ENGAGEMENT_TYPES_ROOT_PATH
} from "../../../../modules/EngagementTypes/paths";
import { openInNewTab } from "../../../../shared/utils/openInNewTab";
import { getEngagementLabelByType } from "../../../Payers/utils/engagement";

export const EngagementsTable: React.FC<{ requirementId: string }> = ({
  requirementId
}) => {
  const history = useHistory();
  const engagementsListAllQuery =
    queriesEngagements.listEngagements.useQueryAll(undefined, {
      refetchOnMount: false,
      retry: false
    });

  const tableData = useMemo(() => {
    const engagements = (engagementsListAllQuery.flatData ?? []).filter(
      e => !e.isDefault
    );
    return engagements
      .filter(e => e.requirementIds?.includes(requirementId))
      .map(engagement => ({
        id: engagement.id ?? "",
        data: engagement
      }));
  }, [engagementsListAllQuery.flatData, requirementId]);

  const columns: Array<WSTableColumn> = [
    {
      config: {
        gridTemplateSizeMax: "0.5fr",
        header: {
          text: "Name"
        }
      },
      renderFunction: rowItem => (
        <WSTableCell
          secondaryText={rowItem.data.description}
          text={rowItem.data.name}
        />
      )
    },
    {
      config: {
        header: {
          text: "Type"
        },
        hideOnScreens: ["XS"]
      },
      renderFunction: rowItem => (
        <WSTableCell
          text={getEngagementLabelByType(rowItem.data.engagementType, {
            descriptive: true
          })}
        />
      )
    }
  ];

  return tableData.length > 0 ? (
    <WSTable
      columns={columns}
      data-testid="requirementEngagementsTable"
      loading={engagementsListAllQuery.isLoading}
      rowActions={({ data: engagement }) => [
        {
          text: "View",
          onClick: () => {
            history.push(buildEngagementTypeDetailsURL(engagement.id ?? ""));
          }
        }
      ]}
      tableData={tableData}
      onRowClick={({ data: engagement }) => {
        history.push(buildEngagementTypeDetailsURL(engagement.id ?? ""));
      }}
      onRowControlClick={({ data: engagement }) => {
        openInNewTab(buildEngagementTypeDetailsURL(engagement.id ?? ""));
      }}
      onRowMousewheelClick={({ data: engagement }) => {
        openInNewTab(buildEngagementTypeDetailsURL(engagement.id ?? ""));
      }}
    />
  ) : (
    <WSEmptyState
      actions={{
        buttons: [
          {
            label: "Open engagements",
            kind: "Secondary",
            onClick: () => {
              history.push(ENGAGEMENT_TYPES_ROOT_PATH);
            }
          }
        ]
      }}
      bgColor="gray"
      description="List of engagements with this requirement will appear here."
      hasBorder
      orientation="horizontal"
      py="3XL"
      title="Requirement is not assigned to an engagement yet"
      type="documents"
    />
  );
};
